import React, {Component} from 'react';
import LazyFourPack from './lazy-four-pack';
import LazyThreePack from './lazy-three-pack';

export const LAZYLOAD_DELAY = 250;

/**
 * Lazy load images for ThreePack or FourPack.
 * Populate images from state vs props. If we are supposed
 * to lazy load, then init state to null and update state
 * from props after the component has mounted.
 */
export default class LazyImagePack extends Component {
    static defaultProps = {
        image1: null,
        image2: null,
        image3: null,
        image4: null,
        isThreePack: false,
        isLazyLoad: false, // Abacus: waterfall
        isLoading: false // Abacus: skeleton_abc
    }

    constructor(props) {
        super(props);
        const isLazyLoaded = true;
        const {
            isLazyLoad,
            image1,
            image2,
            image3,
            image4
        } = props;

        const lazyLoadState = {
            isLazyLoaded: false,
            image1: null,
            image2: null,
            image3: null,
            image4: null
        };

        this.state = (isLazyLoad)
            ? lazyLoadState
            : {isLazyLoaded, image1, image2, image3, image4};
    }

    componentDidMount() {
        const {isLazyLoad} = this.props;

        if (isLazyLoad) {
            this.lazyLoadImages();
        }
    }

    // Fixes component rendering 3x (render 2x max depending on isLazyLoad)
    shouldComponentUpdate(nextProps, nextState) {
        const isImageChange = this.didImagesChange(nextProps);
        const isLazyLoadChange = this.didLazyLoadChange(nextState);
        return isImageChange || isLazyLoadChange;
    }

    didImagesChange = (nextProps) => {
        const {image1, image2, image3, image4} = this.props;
        return image1 !== nextProps.image1
            || image2 !== nextProps.image2
            || image3 !== nextProps.image3
            || image4 !== nextProps.image4;
    }

    didLazyLoadChange = (nextState) => {
        const {isLazyLoaded} = this.state;
        return isLazyLoaded !== nextState.isLazyLoaded;
    }

    lazyLoadImages = () => {
        setTimeout(() => {
            this.updateImageState();
        }, LAZYLOAD_DELAY);
    }

    updateImageState = () => {
        const isLazyLoaded = true;
        const {image1, image2, image3, image4} = this.props;
        this.setState({isLazyLoaded, image1, image2, image3, image4});
    }

    render() {
        const {isLoading, isThreePack} = this.props;
        const {...rest} = this.state;
        if (isThreePack) {
            return <LazyThreePack isLoading={isLoading} {...rest} />;
        }
        return <LazyFourPack isLoading={isLoading} {...rest} />;
    }
}



// WEBPACK FOOTER //
// ./src/universal/abacus/waterfall/lazy-image-pack.js